'use client'

import { referencesProductArticleDetailShownAtom } from '@/feature/product/services/referencesProduct.store'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Button } from '@/ui/buttons/button/Button.client'
import { useAtom } from 'jotai'
import React from 'react'

type ButtonDetailsShownProps = {
  reference: string
  isMonoDiscriminant: boolean
}

export function ButtonDetailsShownComponent({
  reference,
  isMonoDiscriminant,
}: ButtonDetailsShownProps) {
  const { t } = useTranslation(['referencesProductTable'])
  const [referencesProductArticleDetailShown, setReferencesProductArticleDetailShown] = useAtom(
    referencesProductArticleDetailShownAtom,
  )

  const areDetailsShown = referencesProductArticleDetailShown === reference

  const eventCategory = isMonoDiscriminant
    ? 'fiche produit mono-discriminant'
    : 'fiche produit multi-discriminant'

  const handleDetailsButton = () => {
    if (areDetailsShown) {
      setReferencesProductArticleDetailShown(null)
      pushToGtmDataLayer({
        event: 'gaEvent',
        eventCategory,
        eventAction: 'tableau de références',
        eventLabel: 'clic plus de détails - replier',
      })
    } else {
      setReferencesProductArticleDetailShown(reference)
      pushToGtmDataLayer({
        event: 'gaEvent',
        eventCategory,
        eventAction: 'tableau de références',
        eventLabel: 'clic plus de détails - déplier',
      })
    }
  }

  return (
    <Button size="md" className="mt-1" variant="link" onPress={handleDetailsButton}>
      {t(`referencesProductTable:${areDetailsShown ? 'showLess' : 'showMore'}`)}
    </Button>
  )
}

export const ButtonDetailsShown = React.memo(ButtonDetailsShownComponent)
